import { render, staticRenderFns } from "./Startseite.vue?vue&type=template&id=97f99020&"
import script from "./Startseite.vue?vue&type=script&lang=js&"
export * from "./Startseite.vue?vue&type=script&lang=js&"
import style0 from "./Startseite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports